// This file is a modified version of the localization-drawer.js file so that it work consistently with the rest of the drawers and is easily maintainable
class StoreSelectorDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawerClass = "wt-store-selector-drawer";
    this.drawer = this;
    this.classDrawerActive = `${this.drawerClass}--open`;
    this.pageOverlayClass = "wt-store-selector-drawer-overlay";
    this.activeOverlayBodyClass = `${this.pageOverlayClass}-on`;
    this.body = document.body;

    this.triggerQuery = [
      ".wt-store-selector-drawer-trigger",
      ".wt-store-selector-drawer__close",
      `.${this.pageOverlayClass}`,
    ].join(", ");

    this.isOpen = false;
    this.mainTrigger =
      document.querySelector(".wt-store-selector-drawer-trigger") || null;
    this.lastClickedTrigger = null;
  }

  connectedCallback() {
    this.init();
  }

  getFocusableElements() {
    const focusableSelector = "button, [href], input, select, [tabindex]";
    const focusableElements = Array.from(
      this.querySelectorAll(focusableSelector),
    ).filter((el) => !el.hasAttribute("disabled") && el.tabIndex >= 0);

    return {
      first: focusableElements[0],
      last: focusableElements[focusableElements.length - 1],
    };
  }

  temporaryHideFocusVisible() {
    document.body.classList.add("no-focus-visible");
    setTimeout(() => {
      document.body.classList.remove("no-focus-visible");
    }, 200);
  }

  onToggle() {
    if (this.hasAttribute("open")) {
      this.removeAttribute("open");
      this.isOpen = false;
      // Focus back to the trigger that was actually clicked
      const triggerToFocus = this.lastClickedTrigger || this.mainTrigger;
      if (triggerToFocus) triggerToFocus.focus();
    } else {
      this.setAttribute("open", "");
      this.isOpen = true;
      const closeBtn = this.querySelector(".wt-store-selector-drawer__close");
      if (closeBtn) closeBtn.focus();
    }
    this.temporaryHideFocusVisible();
  }

  toggleDrawerClasses() {
    this.onToggle();
    this.drawer.classList.toggle(this.classDrawerActive);
    this.body.classList.toggle(this.activeOverlayBodyClass);
  }

  init() {
    // Trap focus & close on Escape
    this.addEventListener("keydown", (e) => {
      if (!this.isOpen) return;
      const { first, last } = this.getFocusableElements();
      const isTab = e.key === "Tab" || e.keyCode === 9 || e.code === "Tab";
      const isEsc =
        e.key === "Escape" || e.keyCode === 27 || e.code === "Escape";

      if (isEsc) {
        e.preventDefault();
        this.toggleDrawerClasses();
      } else if (isTab) {
        // Focus trap
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    document.querySelectorAll(this.triggerQuery).forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        // Track which trigger was clicked (only for open triggers, not close button or overlay)
        if (trigger.classList.contains("wt-store-selector-drawer-trigger")) {
          this.lastClickedTrigger = trigger;
          // Close mobile menu drawer if it's open
          this.closeMobileMenuDrawer();
        }
        this.toggleDrawerClasses();
      });
    });
  }

  closeMobileMenuDrawer() {
    const mobileMenuDrawer = document.querySelector("#wt-drawer-nav");
    if (mobileMenuDrawer) {
      const closeButton = mobileMenuDrawer.querySelector(".wt-drawer__close");
      if (closeButton) {
        // Check if the mobile menu is actually open
        const menuTrigger = document.querySelector(
          "[aria-controls='wt-drawer-nav']"
        );
        if (menuTrigger && menuTrigger.getAttribute("aria-expanded") === "true") {
          closeButton.click();
        }
      }
    }
  }
}

customElements.define("store-selector-drawer", StoreSelectorDrawer);

